module.exports = __webpack_public_path__ + "img/18.fb0e01f9.jpg";